module.exports = __webpack_public_path__ + "static/wyeast-logo-38b9cfec547d94881b4397f0570ba3e6.jpeg";